import React from 'react';
import {getColorStyle} from '../utils/bolt'
import locale from '../locale'

const RouteDetail = ({route}) => {
  let {description,safety,FAName,FADate,pitchList} = route

  return (
    <div >
      <div style={getColorStyle(safety)}>{locale.R.safety}：{locale.get(safety)}</div>
      {pitchList && pitchList.map(({grade,length},index)=>
        <div key={'p'+index}>Pitch {(index+1)} : {grade}{length&&(' · '+length+'m')}</div>)}

      <div>{FAName && locale.R.FA+' : '+FAName}</div>
      <div>{FADate && locale.R.FADate + ' : '+FADate}</div>
      {description}
    </div>
    )

}

export default RouteDetail


/** WEBPACK FOOTER **
 ** ./src/app/components/RouteDetail.js
 **/